import React from "react";
import css from "./style.scss";
import Toast from "./toast.js";
import {connect} from 'react-redux';
import ExportMini from 'components/account_page/download/mini'


class ToastManager extends React.Component {
  render() {
    return (
      <div className={css.toastManager}>
        {this.props.exports.map(e=><ExportMini key={e.id} {...e}/>)}
        {this.props.toasts.map(t=><Toast key={t.id} duration={t.duration} important={t.important} onClick={t.onClick} id={t.id}>{t.message}</Toast>)}
      </div>
    );
  }
}

const mapStateToProps = (state)=>{
  return {
    toasts:state.toasts,
    exports:state.exports
  }
}

export default connect(mapStateToProps)(ToastManager)



// WEBPACK FOOTER //
// ./src/components/shared/toast/index.js